import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

type Props = {
  close: () => void;
  reject: () => void;

  orderId: string;
};
export const RelatedParcelsModal: React.FC<Props> = ({ orderId, close }) => {
  const navigate = useNavigate();

  return (
    <div className="modal-dialog mw-400">
      <div className={'modal-content'}>
        <div className="modal-header border-bottom-0 p-4 flex flex-column ">
          <button
            type="button"
            className="btn-close pb-4"
            onClick={() => close()}
          />
          <h3>
            <FormattedMessage
              defaultMessage="Создать новую посылку или выбрать существующую?"
              id="order.status-label.related-parcels-modal"
              description="Добавление списания"
            />
          </h3>
        </div>
        <div className="modal-footer">
          <div className={'d-flex w-100 gap-2'}>
            <div className={'w-100'}>
              <button
                type="button"
                className="btn btn-success w-100 "
                onClick={() => {
                  navigate(`/purchases/related-parcel-form/${orderId}`);
                  close();
                }}
              >
                <FormattedMessage
                  defaultMessage="Создать"
                  id="btn.label.create"
                  description="Надпись на кнопке"
                />
              </button>
            </div>
            <div className={'w-100'}>
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={() => {
                  navigate(
                    `/purchases/related-parcel-form/${orderId}/add-existed`,
                  );
                  close();
                }}
              >
                <FormattedMessage
                  defaultMessage="Выбрать"
                  id="btn.label.select"
                  description="Надпись на кнопке"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
